import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Box, Tabs, Tab, Drawer } from "@mui/material";
import styled from "styled-components";
import ToPay from "./ToPay";
import { CustomDateField, Loader } from "../../../components";
import { LoaderContainer } from "../../../CommonStyles";
import { ExpenseService } from "../../../_service/ExpenseService";
import { useAppSelector } from "../../../_app";
import { Notify, Utils } from "../../../utils";
import ToReview from "./ToReview";
import All from "./All";
import exp from "constants";
import ExpenseSubmit from "./ExpesneSubmitForm";
import moment from "moment";
const Container = styled.div``;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  color: #283a44;
  margin: 0;
`;

const StyledInviteButton = styled.p`
  font-size: 16px;
  border: 1px solid #28a745;
  background-color: #28a745;
  color: #ffffff;
  padding: 0.5rem 1.25rem;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  margin: 0;

  &:hover {
    background-color: #218838;
    border-color: #218838;
    transform: scale(1.01);
  }
`;

// For accessibility props
function a11yProps(index: number) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

const ManageExpenseClaims = () => {
  const [value, setValue] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const hasAllAccess = useMemo(
    () => Utils.checkAccess("emp_expense_claim", "emp_expense_all", "add/edit"),
    []
  );
  const hasOwnAccess = useMemo(
    () => Utils.checkAccess("emp_expense_claim", "emp_expense_own", "add/edit"),
    []
  );
  const hasReviewAccess = useMemo(
    () =>
      Utils.checkAccess("emp_expense_claim", "emp_expense_review", "add/edit"),
    []
  );

  const toggleDrawer = (open: boolean) => () => {
    setIsDrawerOpen(open);
  };

  const [fromDate, setFromDate] = useState<string>(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState<string>(
    moment().endOf("month").format("YYYY-MM-DD")
  );

  const companyId = useAppSelector((state: any) => state.user.defaultCompnayId);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [expenseClaims, setExpenseClaims] = useState<any[]>([]);
  const [toPayExpenseClaims, setToPayExpenseClaims] = useState<any[]>([]);

  const getExpenseClaims = async () => {
    setIsLoading(true);
    try {
      const res = await ExpenseService._getExpenseClaims(companyId);
      if (res.status === 200) {
        setExpenseClaims(res?.data?.data);
      }
    } catch (e: any) {
      Utils.showErrorMessage(e);
    }
    setIsLoading(false);
  };

  const getToPayExpenseClaims = async () => {
    setIsLoading(true);
    try {
      const res = await ExpenseService._getToPayExpenseClaims(
        companyId,
        fromDate,
        toDate
      );
      if (res.status >= 200 && res.status < 300) {
        setToPayExpenseClaims(res?.data?.data);
      }
    } catch (e: any) {
      Utils.showErrorMessage(e);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (companyId) {
      getExpenseClaims();
      getToPayExpenseClaims();
    }
  }, [fromDate, toDate, companyId]);


  const expensesGroupedByEmployee = useMemo(() => {
    return expenseClaims.reduce((acc, expense) => {
      const employeeId = expense.employee.id;

      if (!acc[employeeId]) {
        acc[employeeId] = {
          employee_data: {
            id: expense.employee.id,
            name: expense.employee.name,
          },
          expense_data: [],
        };
      }

      const { employee, ...expenseWithoutEmployee } = expense;
      acc[employeeId].expense_data.push(expenseWithoutEmployee);

      return acc;
    }, {});
  }, [expenseClaims]);

  console.log("expensesGroupedByEmployee", expensesGroupedByEmployee);

  const handleOnPay = useCallback(
    async (id, isPayAll = false) => {
      if (toPayExpenseClaims.length === 0) {
        Notify("No approved claims to pay.", 0);
        return;
      }
      let payload = {
        claim_ids: isPayAll ? toPayExpenseClaims.map((claim) => claim.id) : [id],
      };

      console.log("Expense paid:", payload);

      try {
        setIsLoading(true);
        const { status } = await ExpenseService._payExpenseClaims(payload);
        if (status >= 200 && status < 300) {
          Notify(`Expense claims paid successfully!`, 1);
          // setValue(1);
          getToPayExpenseClaims();
        }
      } catch (error: any) {
        Utils.showErrorMessage(error);
      }
      setIsLoading(false);
    },
    [toPayExpenseClaims]
  );

  return (
    <Container>
      <HeaderContainer>
        <Title>Manage Expense Claims</Title>
        {/* <StyledInviteButton onClick={toggleDrawer(true)}>New Expense</StyledInviteButton> */}
      </HeaderContainer>

      <Drawer anchor="right" open={isDrawerOpen} onClose={toggleDrawer(false)}>
        <Box sx={{ width: 1035, padding: 2 }}>
          <ExpenseSubmit />
        </Box>
      </Drawer>

      <DateFilterContainer>
        <CustomDateField
          label="From"
          date={fromDate}
          setDate={(date: any) => setFromDate(() => date)}
          labelWidth="45px"
        />
        <CustomDateField
          label="To"
          date={toDate}
          setDate={(date: any) => setToDate(() => date)}
          labelWidth="20px"
        />
      </DateFilterContainer>

      <Box
        sx={{
          borderBottom: 1,
          borderColor: "#28A745",
          mt: 2,
          ".MuiTabs-indicator": {
            backgroundColor: "#28A745",
          },
          ".Mui-selected": {},
        }}
      >
        <Tabs value={value} onChange={handleChange} aria-label="expense tabs">
         
          <Tab
            label="To Pay"
            {...a11yProps(0)}
            sx={{
              "&.Mui-selected": {
                color: "inherit",
              },
              "&:hover": {
                backgroundColor: "#28A74522",
              },
            }}
            onClick={() => {
              getToPayExpenseClaims();
            }}
          />
          <Tab
            label="All"
            {...a11yProps(1)}
            sx={{
              "&.Mui-selected": {
                color: "inherit",
              },
              "&:hover": {
                backgroundColor: "#28A74522",
              },
            }}
            onClick={() => {
              getExpenseClaims();
            }}
          />
        </Tabs>
      </Box>

      <Box sx={{ mt: 2 }}>
        {isLoading ? (
          <LoaderContainer>
            <Loader />
          </LoaderContainer>
        ) : (
          <>
            <CustomTabPanel value={value} index={0}>
              <All
                data={toPayExpenseClaims || []}
                showPay={true}
                onPay={handleOnPay}
              />
            </CustomTabPanel>

            <CustomTabPanel value={value} index={1}>
              <All data={expenseClaims} showFilter={true} />
            </CustomTabPanel>
          </>
        )}
      </Box>
    </Container>
  );
};

export default ManageExpenseClaims;

const DateFilterContainer = styled.div`
  display: flex;
  gap: 1rem;
  width: 50%;
  margin-top: 1rem;
  align-items: center;

  .MuiFormControl-root {
    flex: 1;
  }

  .MuiInputLabel-root {
    color: #283a44;
    font-weight: 500;
  }

  .MuiOutlinedInput-root {
    border-radius: 4px;

    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: #28a745;
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: #28a745;
    }
  }

  .MuiInputLabel-root.Mui-focused {
    color: #28a745;
  }
`;
